<template>
  <form action="#" method="post" @submit="onSaveMedichalCheckup">
    <b-row v-for="(state, index) in medical_checkup" v-bind:key="index">
      <b-col md="12">
        <div
          v-if="medical_checkup.length > 1 && index > 0"
          class="d-flex w-100 px-4 my-1 justify-content-end cursor-pointer position-absolute top-0"
          @click="deleteMedicalCheckupForm(index)"
        >
          <i class="fa fa-trash text-danger"></i>
        </div>
        <b-form-group label="Nomor / Name Document" label-for="document-number">
          <b-form-input
            plain
            id="document-number"
            name="document-number"
            v-model="state.nama_document"
            placeholder="Masukkan nomor / nama document"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Attachment" label-for="attachment">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="validatedCustomFile"
              accept=".pdf,.doc,.docx"
              @change="(event) => prefiewFiles(event, state)"
            />

            <label
              class="custom-file-label"
              for="validatedCustomFile"
              v-if="!state.file"
              >Browse file...</label
            ><label
              class="custom-file-label"
              for="validatedCustomFile"
              v-else
              >{{ state.label_file }}</label
            >
            <!-- this.medical_checkup -->
          </div>
          <span
            ><small
              >Max File Size: 5 mb <br />Type Allowed: .pdf, .docx, .doc</small
            ></span
          >
        </b-form-group>
        <b-form-group label="Placed Issued" class="w-100">
          <b-form-input
            placeholder="Masukkan tempat diterbitkan"
            v-model="state.place_issued"
            plain
          >
          </b-form-input>
        </b-form-group>
        <div class="d-flex">
          <b-form-group label="Date Issued" class="w-50 mr-2">
            <date-picker
              class="w-100"
              v-model="state.date_issued"
              value-type="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
          <b-form-group label="Date Expired" class="w-50 mr-2">
            <date-picker
              class="w-100"
              v-model="state.date_expired"
              value-type="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
        </div>
        <b-form-group label="Notes" class="w-100">
          <b-form-select v-model="state.notes" :options="notesOption" plain>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Remarks" label-for="remarks">
          <b-form-textarea
            id="remarks"
            name="remarks"
            rows="3"
            v-model="state.remarks"
            placeholder="Masukan Remarks"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <hr v-if="index !== medical_checkup.length - 1" />
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="12">
        <b-button variant="success" class="mt-1" @click="addMedicalCheckupForm"
          ><i class="fa fa-plus"></i> ADD FORM</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col :md="'6'">
        <b-button
          variant="secondary"
          block
          @click="$bvModal.hide('medical-checkup')"
          >Close</b-button
        >
      </b-col>
      <b-col :md="'6'">
        <b-button variant="primary" block type="submit" :disabled="saving"
          ><i class="fa fa-file-signature" v-if="!saving"></i>
          <span v-if="!saving">SUBMIT</span>
          <span v-if="saving" class="spinner-border spinner-border-sm" />
        </b-button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { crewingActions } from '@src/Utils/helper'
import moment from 'moment'

export default {
  name: 'ContentMedicalCheckup',
  data() {
    return {
      saving: false,
      notesOption: [
        { text: 'Fit To Work', value: 'FIT_TO_WORK' },
        { text: 'Fit To Work With Notes', value: 'FIT_TO_WORK_WITH_NOTES' },
        { text: 'Other', value: 'OTHER' },
      ],
      medical_checkup: [
        {
          label_file: '',
          file: '',
          nama_document: '',
          notes: '',
          date_issued: '',
          date_expired: '',
          place_issued: '',
          remarks: '',
        },
      ],
    }
  },
  props: {
    getProfileCrew: {
      type: Function,
      default: () => {},
    },
  },
  computed: {},
  mounted() {},
  methods: {
    ...crewingActions,
    prefiewFiles: function (event, state) {
      const input = event.target

      if (input.files && input.files[0]) {
        state.label_file = input.files[0].name
        state.file = input.files[0]
      }
    },

    async onSaveMedichalCheckup(e) {
      e.preventDefault()
      this.saving = true

      let tempMedicalCheckup = []
      this.medical_checkup.map((item) => {
        tempMedicalCheckup.push({
          file: item.file,
          nama_document: item.nama_document,
          notes: item.notes,
          date_issued: item.date_issued,
          date_expired: item.date_expired,
          place_issued: item.place_issued,
          remarks: item.remarks,
        })
      })

      let formData = new FormData()

      tempMedicalCheckup.forEach((item, index) => {
        for (const property in item) {
          formData.append(
            `medical_checkup[${index}][${property}]`,
            item[property]
          )
        }
      })

      const { status, data } = await this.medicalCheckupCrew({
        data: formData,
        id: Number(this.$route.query.id),
      })

      if (status !== 'success') {
        this.saving = false
        // Normalize backend validation errors like { 'medical_checkup.0.file': ['message'] }
        let message = ''
        if (typeof data === 'string') {
          message = data
        } else if (data && typeof data === 'object') {
          const firstKey = Object.keys(data)[0]
          const firstVal = data[firstKey]
          if (Array.isArray(firstVal) && firstVal.length) {
            message = firstVal[0]
          } else if (typeof firstVal === 'string') {
            message = firstVal
          } else {
            try {
              message = JSON.stringify(data)
            } catch (e) {
              message = 'Validation error. Please check your input.'
            }
          }
        } else {
          message = 'Something went wrong. Please try again.'
        }
        this.$swal('Oops!', message, 'error')
        return
      }

      this.$swal(`Success!`, `${data}`, 'success')

      this.saving = false
      this.medical_checkup = [
        {
          label_file: '',
          file: '',
          nama_document: '',
          notes: '',
          date_issued: '',
          date_expired: '',
          place_issued: '',
          remarks: '',
        },
      ]
      this.$nextTick(() => {
        this.$bvModal.hide('medical-checkup')
      })
      this.getProfileCrew()
    },

    // Medical Checkup Adding and Removing Forms
    addMedicalCheckupForm() {
      this.medical_checkup.push({
        label_file: '',
        file: '',
        nama_document: '',
        notes: '',
        date_issued: '',
        date_expired: '',
        place_issued: '',
        remarks: '',
      })
    },
    deleteMedicalCheckupForm(index) {
      this.medical_checkup.splice(index, 1)
    },
  },
}
</script>
